import { render } from "./DayViewWorkAreaGridGroupBar.vue?vue&type=template&id=eef2f4be"
import script from "./DayViewWorkAreaGridGroupBar.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaGridGroupBar.vue?vue&type=script&lang=ts"
script.render = render

export default script